<template>
  <el-upload
    class="upload-demo"
    action
		id="uploadImage"
	ref="uploadPag"
    :limit="1"
    accept="image/png, image/gif, image/jpg, image/jpeg"
    :on-change="uploadChange"
    :on-preview="handlePictureCardPreview"
    :on-remove="handleRemove"
    :auto-upload="false"
	:file-list="fileList"
	:show-file-list="false"
	style="display: inline-block;"
  >
    <el-button slot="trigger" type="primary">上传图片</el-button>
  </el-upload>
</template>
<script>
	import { uploadOss } from "@/api/config"
export default {
  data() {
    return {
      fileList: [],
    };
  },
  methods: {
	  handleUpload(){
		  document.querySelector('#uploadImage input').click()
	  },
    async uploadChange(file,fileList) {
	  let that = this;
	  if(that.$refs.uploadPag.uploadFiles.length>1){
		  that.$refs.uploadPag.uploadFiles.shift();
	  }
      const isIMAGE =
        file.raw.type === "image/jpeg" ||
        file.raw.type === "image/png" ||
        file.raw.type === "image/jpg" ||
        file.raw.type === "image/gif";
      /*var isIMAGE = /^image\/(jpeg|png|jpg|gif)$/.test(file.type);*/
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isIMAGE) {
        this.$message.error("上传文件只能是图片格式!");
        return false;
      }
      if (!isLt5M) {
        this.$message.error("上传文件大小不能超过 5MB!");
        return false;
      }
			console.log(file.raw);
	   const loading = this.$loading({
		lock: true,
		text: '上传中',
		spinner: 'el-icon-loading',
		background: 'rgba(0, 0, 0, 0.7)'
	  });
	  let formData =new FormData();
	  formData.append("file", file.raw)
	  that.$refs.uploadPag.clearFiles();
	  await uploadOss(formData).then(res=>{
		  loading.close();
		  that.$message.success("上传成功");
		  console.log(res)
		  that.$refs.uploadPag.clearFiles();
		  that.$emit("upload", res.data?res.data:'');
	  }).catch(()=>{
		  that.$refs.uploadPag.clearFiles();
		  loading.close();
	  })
      //this.$emit("upload", file.raw);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/common/ImgUpload.vue